<template>
    <div class="page--login">
        <div class="container">
            <div v-show="!isLoading && !registrationSuccess">
                <div class="grid desktop--horizontal--center">

                    <div class="grid__item desktop--push--4 desktop--8">
                        <h1 class="title--3">{{ $t("password-forgotten") }}</h1>
                        <p>{{ $t("enter-the-email-associated-with-your-account") }}</p>
                        <br />
                    </div>

                    <div class="grid__item desktop--4">
                        <form
                            class="page--login__form form"
                            action="#"
                            @submit.prevent="submitForm">

                            <div
                                class="field field--text">
                                <label
                                    class="field__label field--text__label"
                                    for="field-email">{{ $t("email") }}</label>
                                <input
                                    required
                                    name="email"
                                    data-label="Email"
                                    v-model="email"
                                    id="field-email"
                                    class="field__input field--text__input"
                                    type="email"
                                />

                                <p
                                    id="field-error-email"
                                    v-if="error.errors !== undefined && error.errors['email'] !== undefined && error.errors['email'].length > 0"
                                    class="field__message--error"
                                >
                                    {{ error.errors['email'][0] }}
                                </p>
                            </div>

                            <div class="field">
                                <button class="button button--primary button--fullwidth">{{ $t("validate") }}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div v-if="!isLoading && registrationSuccess">
                <div class="grid__item desktop--push--4 desktop--8">
                    <h1 class="title--3">{{ $t("password-forgotten") }}</h1>
                    <p>{{ $t("reset-password-mail-sent") }}</p>
                    <p><strong>{{ email }}</strong></p>
                </div>
            </div>

            <div v-if="isLoading">
                <HorizontalBubbleLoader />
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import HorizontalBubbleLoader from "@/components/loaders/HorizontalBubbleLoader.vue";

import { userPasswordResetEmail } from "@/utils/api/usersApi.js";
import { purify } from "@/utils/helpers/string.js";
import { setCookie } from "@/utils/helpers/cookie";
import { validateForm } from "@/utils/helpers/validate-form.js";

export default {
    name: "ForgotPassword",
    components: {
        HorizontalBubbleLoader
    },
    data() {
        return {
            isLoading: false,
            registrationSuccess: false,
            email: "",
            error: ""
        };
    },
    computed: {
        user() {
            return {
                email: this.email,
            };
        },
    },
    mounted: function() {
    },
    methods: {
        submitForm() {
            const isFormValid = validateForm(this.$el);

            if(isFormValid.value === true) {

                userPasswordResetEmail(this.user).then((res) => {

                    this.isLoading = true;

                    if (res.data && res.data.status === "ok") {
                        this.registrationSuccess = true;
                        this.isLoading = false;

                    } else {
                        this.isLoading = false;
                        // Handle Error
                        let message = this.$t("a-server-error-occured-please-try-later");

                        switch (res.status) {
                        case 401:
                            message = this.$t("wrong-username-password");
                            break;
                        }

                        this.$notificationsBar.alert(message, {type: "warning"});
                    }
                });
            } else {
                // There are some errors
                this.error = isFormValid.error;

                //Set focus to first error field for screen reader
                if(this.error.errors !== undefined && Object.keys(this.error.errors).length > 0) {
                    let errorFieldName = Object.keys(this.error.errors)[0];
                    let errorField = document.getElementById("field-" + errorFieldName.toLowerCase());
                    if(errorField) {
                        errorField.focus();
                    }
                }
            }
        }
    }
};
</script>